export default (milliseconds: number) => {
  const createdDate = new Date(milliseconds * 1000)
  const today = new Date()
  const differenceInTime = today.getTime() - createdDate.getTime()
  const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24))

  if (differenceInDays < 1) return 'today'
  if (differenceInDays >= 30) return `${Math.floor(differenceInDays / 30)} month ago`
  if (differenceInDays >= 365) return `${Math.floor(differenceInDays / 365)} year ago`
  return `${differenceInDays}d ago`
}